var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-flex pt-2 pb-8"},_vm._l((_vm.steps),function(step){return _c('div',{staticClass:"h-1 rounded-lg w-8",class:[ (step < _vm.steps) ? 'mr-3' : '', (step <= _vm.currentStep) ? 'bg-primary-500' : 'bg-gray-500' ]})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }